import { ElementObj } from '../../../../viewer/elements/element-obj';
import { SubscriptionTopic } from '../../../../viewer/messaging/pubsub';
import { useDialog } from '../../../hooks/use-dialog';
import { useSubscribe } from '../../../hooks/use-subscribe';

/**
 * Shows the dialog upon receiving the ShowDeleteAssetDialog notification.
 */
export function useSubscribeShowDeleteAssetDialog(
  asset: ElementObj,
  dialog: ReturnType<typeof useDialog>,
  isSharedView: boolean,
) {
  useSubscribe(SubscriptionTopic.ShowDeleteAssetDialog, (message) => {
    if (message.asset.uuid === asset.uuid && !isSharedView) {
      dialog.show(message.position);
    }
  });
}
